/***
 * 回单管理
 *  */
// 定制逻辑处理
export default {
  // 回单签收提取自定义时间202510170913272177257
  sign_receipt_custom_time: ["81820"],
  // 回单总账 批量速配功能
  reconciliation_general_ledger_matched_quickly: ["98259",'82635'], // 回单总账 批量速配功能 202511051739202001243
  // 回单上传图片扩充到40张
  hd_upload_img_receipt_expand_40: ['82635','81820'] // 202511261654217131107 回单上传图片扩充到40张
}
